// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__3VdTo","wrap":"styles_wrap__VMvam"};